import React, { useEffect, useState } from 'react';

const Lightbox = ({ image, onClose }) => {
    const [isZoomed, setIsZoomed] = useState(false);

    // Every image opens fitted to the screen; zoom is per-viewing.
    useEffect(() => setIsZoomed(false), [image]);

    useEffect(() => {
        if (!image) return undefined;
        const onKeyDown = (event) => event.key === 'Escape' && onClose();
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [image, onClose]);

    if (!image) return null;

    return (
        <div
            className="lightbox"
            role="dialog"
            aria-modal="true"
            aria-label={image.alt}
            onClick={onClose}
        >
            <button type="button" className="lightbox__close" aria-label="Close">
                &times;
            </button>

            {/* Scroll container: once zoomed the image outgrows it and can be
                panned, which is how a tall portrait photo stays readable on a
                phone. */}
            <div
                className="lightbox__viewport"
                data-zoomed={isZoomed}
                onClick={(event) => event.stopPropagation()}
            >
                <img
                    src={image.src}
                    alt={image.alt}
                    onClick={() => setIsZoomed((zoomed) => !zoomed)}
                />
            </div>

            <p className="lightbox__hint" aria-hidden="true">
                {isZoomed ? 'Click or tap the image to zoom out' : 'Click or tap the image to zoom in'}
            </p>
        </div>
    );
};

export default Lightbox;
